<template>
  <div class="campaign-child">
    <h2 class="campaign-subtitle">Покана</h2>

    <div class="campaign-content" v-html="campaign.invite"></div>
  </div>
</template>

<script>
export default {
  name: 'NCCampaignInvite',

  computed: {
    campaign () {
      return this.$store.getters.ncCampaign
    }
  }
}
</script>
